export const adminDashboard = {
  'admin.dashboard.title': 'Admin Dashboard',
  'admin.dashboard.subtitle': 'Platform overview and key metrics',
  'admin.dashboard.totalEarnings.lifetime': 'Total Lifetime Earnings',
  'admin.dashboard.totalEarnings.lastMonth': 'Last Month Earnings',
  'admin.dashboard.additionalMetrics': 'Additional Metrics Coming Soon',
  'admin.dashboard.charts.accountsProfits': 'Trading Account Profits Over Time',
  'admin.dashboard.charts.commissionsOverTime': 'Commission History',
  'admin.dashboard.charts.totalEarnings': 'Total Earnings Over Time',
  'admin.dashboard.users.title': 'Total Users',
  'admin.dashboard.users.active': 'Active Users',
  'admin.dashboard.users.newThisMonth': 'New This Month',
  'admin.dashboard.communityValue.title': 'Total Community Value',
  'admin.dashboard.communityValue.description': 'Combined value of all user accounts',
  'admin.dashboard.totalEarnings.accountProfit': 'Account Profit',
  'admin.dashboard.totalEarnings.commissionProfit': 'Commission Profit',
  'admin.dashboard.totalEarnings.description': 'Combined platform earnings to date',
  'admin.dashboard.lastMonthEarnings.description': 'Platform earnings for',
};